<script setup lang="ts">
import { capitalize, debounce } from 'lodash'
import { ref, watch } from 'vue'
import { useExtendedI18n } from '@/i18n'
import { VTable } from '@/modules/shared/components'
import { AllGroup } from '../types'

const props = defineProps<{
  entities: AllGroup[]
  skeleton: boolean
}>()

const { t } = useExtendedI18n()
</script>

<template>
  <div class="mb-5 mt-5 text-xs"></div>
  <VTable
    ref="table"
    :columns="[
      {
        key: 'group_name',
        name: capitalize(t('shared.group')),
        type: 'string',
        is_visible: true,
      },
      {
        key: 'group_subdomain',
        name: capitalize(t('shared.subdomain')),
        type: 'string',
        is_visible: true,
      },
      {
        key: 'date_added',
        name: capitalize(t('shared.date added')),
        type: 'date',
        is_visible: true,
      },
    ]"
    :items="entities"
    name="all-group"
    :skeleton="!entities || entities.length === 0"
    :slots="['group_name']"
  >
    <template #group_name="{ item }">
      <div>
        <RouterLink
          class="hyperlink font-medium text-blue-700 hover:underline"
          :to="{
            name: 'dashboard',
            params: {
              slug: item.group_subdomain,
            },
          }"
        >
          {{ item.group_name }}
        </RouterLink>
      </div>
    </template>
  </VTable>
</template>
